export default __webpack_public_path__ + "static/media/features-03-image-01.d42e85a8.png";